export function EntriesSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/entries.svg'"></ng-include>`
    }
}